import { render, staticRenderFns } from "./Perfis.vue?vue&type=template&id=3542b403&scoped=true&"
import script from "./Perfis.vue?vue&type=script&lang=js&"
export * from "./Perfis.vue?vue&type=script&lang=js&"
import style0 from "./Perfis.vue?vue&type=style&index=0&id=3542b403&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3542b403",
  null
  
)

export default component.exports